"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const models_1 = require("../models");
const group_1 = require("./group");
const FilteredPatientChats_1 = require("./group/FilteredPatientChats");
const broadcast_1 = require("./broadcast");
const roleAccess_1 = require("../roleAccess/roleAccess");
const private_1 = require("./private");
const HiddenChats_1 = require("./group/HiddenChats");
const FilteredNonPatientChats_1 = require("./group/FilteredNonPatientChats");
const FilteredHiddenChats_1 = require("./group/FilteredHiddenChats");
class ChatManager {
    constructor(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage) {
        this.organizationUser = organizationUser;
        this.patientChats = new group_1.PatientChats(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage);
        this.filteredPatientChats = new FilteredPatientChats_1.FilteredPatientChats(httpAdapter, organizationUser, socketAdapter, userDirectory, hhnStorage);
        this.privateChats = new private_1.PrivateChats(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage);
        this.filteredPrivateChats = new private_1.FilteredPrivateChats(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage);
        this.nonPatientChats = new group_1.NonPatientChats(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage);
        this.filteredNonPatientChats = new FilteredNonPatientChats_1.FilteredNonPatientChats(httpAdapter, organizationUser, socketAdapter, userDirectory, hhnStorage);
        this.broadcastChats = new broadcast_1.BroadcastChats(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage);
        this.hiddenChats = new HiddenChats_1.HiddenChats(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage);
        this.filteredHiddenChats = new FilteredHiddenChats_1.FilteredHiddenChats(httpAdapter, organizationUser, socketAdapter, userDirectory, hhnStorage);
    }
    init() {
        this.patientChats.init();
        this.filteredPatientChats.init();
        this.nonPatientChats.init();
        this.filteredNonPatientChats.init();
        this.privateChats.init();
        this.filteredPrivateChats.init();
        this.hiddenChats.init();
        this.filteredHiddenChats.init();
        this.broadcastChats.init();
    }
    destroy() {
        this.patientChats.destroy();
        this.filteredPatientChats.destroy();
        this.nonPatientChats.destroy();
        this.filteredNonPatientChats.destroy();
        this.privateChats.destroy();
        this.filteredPrivateChats.destroy();
        this.hiddenChats.destroy();
        this.filteredHiddenChats.destroy();
        this.broadcastChats.destroy();
    }
    fetchAllChats() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.patientChats.fetchChats();
            yield this.nonPatientChats.fetchChats();
            yield this.privateChats.fetchChats();
            this.organizationUser.hasAccess(roleAccess_1.FEATURES.VIEW_HIDDEN_GROUPS) &&
                (yield this.hiddenChats.fetchChats());
            this.organizationUser.hasAccess(roleAccess_1.FEATURES.VIEW_BROADCAST) &&
                (yield this.broadcastChats.fetchChats());
        });
    }
    getPatientChatManager() {
        return this.patientChats;
    }
    getFilteredPatientChatManager() {
        return this.filteredPatientChats;
    }
    getNonPatientChatManager() {
        return this.nonPatientChats;
    }
    getFilteredNonPatientChatManager() {
        return this.filteredNonPatientChats;
    }
    getBroadcastChatManager() {
        return this.broadcastChats;
    }
    getHiddenGroupChatManager() {
        return this.hiddenChats;
    }
    getFilteredHiddenGroupChatManager() {
        return this.filteredHiddenChats;
    }
    getPrivateChatManager() {
        return this.privateChats;
    }
    getFilteredPrivateChatManager() {
        return this.filteredPrivateChats;
    }
    getChatManagerForGroupType(groupType) {
        if (groupType) {
            switch (groupType.toUpperCase()) {
                case models_1.GROUP_TYPE.PRIVATE:
                    return this.getPrivateChatManager();
                case models_1.GROUP_TYPE.PATIENT:
                    return this.getPatientChatManager();
                case models_1.GROUP_TYPE.NON_PATIENT:
                    return this.getNonPatientChatManager();
                case models_1.GROUP_TYPE.BROADCAST:
                    return this.getBroadcastChatManager();
                case models_1.GROUP_TYPE.HIDDEN:
                    return this.getHiddenGroupChatManager();
                default:
                    return null;
            }
        }
        return null;
    }
}
exports.default = ChatManager;
